module.exports = __webpack_public_path__ + "img/courseDetail.fb3d785d.png";